module.exports = __webpack_public_path__ + "static/media/errordoggo.75f1c0fc.png";